var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _g16, _path18, _g17, _path19, _g18, _path20, _g19, _path21, _path22, _path23, _path24, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnHuawei(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 48,
    viewBox: "0 0 169 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 48,
    rx: 15,
    fill: "#171B1F"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69963_26295)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.596 31.3534H61.7065L60.5201 34.6407H58.3707L63.1535 22.3589H65.1838L70.0733 34.6407H67.8246L66.5985 31.3534H66.596ZM62.3295 29.6735H65.9706L64.6675 26.1562C64.4888 25.6712 64.3126 25.1337 64.1389 24.5463C63.98 25.0662 63.8087 25.5962 63.6251 26.1387L62.3295 29.6735Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9346 27.7335C70.9346 27.056 70.9122 26.3086 70.8676 25.4936H72.8134C72.8854 25.8786 72.9376 26.2661 72.9624 26.6561C73.3024 26.2461 73.7268 25.9136 74.2083 25.6836C74.6874 25.4536 75.2111 25.3311 75.7422 25.3236C76.3652 25.3136 76.9783 25.4911 77.4995 25.8336C78.0207 26.1761 78.4302 26.6661 78.676 27.2435C79.0185 28.0385 79.1798 28.8984 79.15 29.7634C79.1724 30.7058 78.9812 31.6433 78.5941 32.5007C78.2714 33.2132 77.7427 33.8131 77.0751 34.2206C76.39 34.6181 75.6107 34.8206 74.8214 34.8056C74.1984 34.8056 73.5829 34.6981 72.9946 34.4931V38.2804L70.9147 38.4604L70.9321 27.7335H70.9346ZM76.4 32.4007C76.8219 31.8408 77.0378 31.0008 77.0378 29.8809C77.0378 28.8609 76.8616 28.1135 76.5092 27.641C76.3503 27.421 76.1393 27.2435 75.8986 27.1235C75.6554 27.0035 75.3898 26.9435 75.1192 26.951C74.7296 26.946 74.3473 27.0435 74.0073 27.231C73.6449 27.4385 73.3173 27.696 73.0319 28.001V32.9007C73.2627 33.0107 73.5059 33.0907 73.7541 33.1407C74.0222 33.1982 74.2977 33.2282 74.5707 33.2307C74.9207 33.2507 75.2682 33.1882 75.5883 33.0432C75.906 32.8982 76.1865 32.6782 76.4 32.4007Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.4183 27.7335C80.4183 27.056 80.396 26.3086 80.3513 25.4936H82.2972C82.3717 25.8761 82.4238 26.2661 82.4511 26.6561C83.2602 25.7686 84.1885 25.3236 85.231 25.3236C85.8539 25.3136 86.467 25.4911 86.9882 25.8336C87.5094 26.1761 87.919 26.6661 88.1647 27.2435C88.5072 28.0385 88.6685 28.8984 88.6388 29.7634C88.6636 30.7058 88.4799 31.6408 88.0977 32.5007C87.7725 33.2132 87.2439 33.8131 86.5762 34.2206C85.8912 34.6206 85.1118 34.8231 84.3225 34.8056C83.6995 34.8056 83.084 34.6981 82.4958 34.4931V38.2804L80.4159 38.4604V27.7335H80.4183ZM85.8912 32.4007C86.3131 31.8283 86.5241 30.9883 86.5241 29.8809C86.5241 28.8609 86.3479 28.1135 85.9979 27.641C85.839 27.421 85.6281 27.2435 85.3873 27.1235C85.1441 27.0035 84.8785 26.9435 84.608 26.951C84.2183 26.946 83.8361 27.0435 83.496 27.231C83.1337 27.4385 82.806 27.696 82.5206 28.001V32.9007C82.7514 33.0082 82.9947 33.0907 83.2429 33.1407C83.5109 33.1982 83.7864 33.2282 84.0594 33.2307C84.4094 33.2507 84.7569 33.1857 85.0746 33.0407C85.3923 32.8957 85.6727 32.6757 85.8887 32.3982L85.8912 32.4007Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.4611 34.0607C91.5725 33.5707 90.8502 32.8208 90.3911 31.9133C89.8872 30.8859 89.639 29.751 89.6688 28.606C89.6316 27.3811 89.9195 26.1687 90.5028 25.0912C91.0289 24.1563 91.8182 23.4013 92.7713 22.9214C93.774 22.4289 94.876 22.1789 95.9905 22.1964C96.6656 22.1939 97.3407 22.2714 97.9984 22.4314C98.614 22.5764 99.2096 22.7914 99.778 23.0689L99.2394 24.6788C98.2565 24.1788 97.1744 23.9063 96.0724 23.8838C95.2955 23.8713 94.5286 24.0638 93.8485 24.4438C93.2032 24.8163 92.6844 25.3762 92.3618 26.0512C91.9895 26.8511 91.8083 27.7286 91.8331 28.611C91.8182 29.406 91.9572 30.1984 92.2402 30.9409C92.4958 31.5984 92.9475 32.1608 93.5308 32.5533C94.196 32.9733 94.9704 33.1783 95.7547 33.1458C96.1617 33.1458 96.5663 33.1108 96.9659 33.0433C97.3531 32.9808 97.7353 32.8808 98.1027 32.7458V30.2484H95.2831V28.621H100.123V33.7982C99.4206 34.1282 98.6859 34.3807 97.9289 34.5507C97.1794 34.7257 96.4124 34.8132 95.643 34.8132C94.536 34.8407 93.4414 34.5807 92.4635 34.0582L92.4611 34.0607Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.507 34.6406C107.428 34.2406 107.38 33.8357 107.363 33.4282C107.016 33.8357 106.591 34.1681 106.115 34.4081C105.576 34.6831 104.98 34.8206 104.377 34.8106C103.883 34.8181 103.394 34.7106 102.948 34.5006C102.523 34.3006 102.166 33.9757 101.927 33.5682C101.662 33.1082 101.53 32.5807 101.548 32.0483C101.533 31.6433 101.61 31.2433 101.776 30.8733C101.942 30.5059 102.191 30.1809 102.501 29.9259C103.134 29.3959 104.191 29.1309 105.673 29.1334C106.224 29.1334 106.775 29.1734 107.321 29.2509V29.0709C107.321 28.2635 107.15 27.696 106.81 27.3635C106.403 27.0111 105.874 26.8311 105.335 26.8686C104.854 26.8736 104.377 26.9411 103.913 27.0636C103.454 27.1761 103.005 27.3311 102.573 27.5285L102.245 26.0061C102.717 25.8036 103.206 25.6462 103.707 25.5387C104.337 25.3962 104.983 25.3237 105.628 25.3262C106.313 25.3062 106.993 25.4312 107.629 25.6861C108.187 25.9361 108.644 26.3736 108.917 26.9236C109.257 27.661 109.418 28.471 109.381 29.2834V32.9232C109.381 33.2957 109.403 33.8707 109.448 34.6431H107.507V34.6406ZM106.261 32.9607C106.661 32.7732 107.021 32.5082 107.321 32.1783V30.4984C106.859 30.4434 106.395 30.4134 105.931 30.4059C105.072 30.4059 104.479 30.5459 104.149 30.8258C103.988 30.9633 103.861 31.1358 103.774 31.3283C103.69 31.5233 103.647 31.7333 103.655 31.9458C103.64 32.1283 103.665 32.3133 103.727 32.4857C103.789 32.6582 103.886 32.8157 104.015 32.9482C104.285 33.1782 104.633 33.2957 104.988 33.2757C105.43 33.2682 105.866 33.1607 106.261 32.9582V32.9607Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.987 32.4458V21.6389L113.054 21.4714V32.0758C113.024 32.3708 113.094 32.6658 113.253 32.9158C113.332 33.0007 113.429 33.0682 113.538 33.1107C113.647 33.1532 113.764 33.1707 113.881 33.1582C114.069 33.1507 114.256 33.1182 114.437 33.0632L114.682 34.5632C114.449 34.6507 114.208 34.7156 113.963 34.7531C113.697 34.8006 113.429 34.8231 113.159 34.8256C111.712 34.8156 110.987 34.0232 110.987 32.4458Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.162 32.4458V21.6389L118.232 21.4714V32.0758C118.202 32.3708 118.271 32.6658 118.43 32.9158C118.51 33.0007 118.607 33.0682 118.716 33.1107C118.825 33.1532 118.942 33.1707 119.058 33.1582C119.247 33.1507 119.433 33.1182 119.614 33.0632L119.855 34.5632C119.624 34.6507 119.383 34.7156 119.138 34.7531C118.87 34.8006 118.602 34.8231 118.331 34.8256C116.884 34.8156 116.162 34.0232 116.159 32.4458H116.162Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.358 30.3334H122.416C122.511 32.2508 123.417 33.2082 125.134 33.2082C125.576 33.2082 126.015 33.1532 126.445 33.0507C126.884 32.9482 127.311 32.8083 127.728 32.6308L128.185 34.0657C127.115 34.5731 125.943 34.8281 124.759 34.8106C123.913 34.8356 123.072 34.6431 122.317 34.2507C121.664 33.8957 121.141 33.3407 120.823 32.6658C120.471 31.8833 120.299 31.0309 120.322 30.1734C120.297 29.2735 120.48 28.381 120.853 27.5636C121.17 26.8686 121.684 26.2861 122.33 25.8837C122.99 25.4912 123.747 25.2912 124.514 25.3062C125.276 25.2787 126.025 25.4912 126.663 25.9137C127.237 26.3136 127.681 26.8761 127.941 27.5286C128.229 28.2385 128.371 29.001 128.358 29.7684V30.3309V30.3334ZM126.331 29.0035C126.336 28.4085 126.139 27.8311 125.775 27.3636C125.611 27.1786 125.41 27.0336 125.184 26.9361C124.958 26.8386 124.715 26.7936 124.469 26.8036C124.223 26.7986 123.978 26.8461 123.752 26.9411C123.526 27.0361 123.32 27.1811 123.151 27.3636C122.759 27.8236 122.518 28.396 122.464 28.9985L126.328 29.0035H126.331Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.934 27.791C129.934 27.2886 129.91 26.5236 129.865 25.4962H131.811C131.843 25.7512 131.875 26.0561 131.908 26.4061C131.94 26.7561 131.957 27.0461 131.967 27.2686C132.176 26.9111 132.414 26.5736 132.68 26.2561C132.908 25.9837 133.186 25.7587 133.496 25.5862C133.821 25.4087 134.189 25.3187 134.561 25.3262C134.841 25.3187 135.124 25.3537 135.395 25.4287L135.134 27.2436C134.809 27.1486 134.467 27.1236 134.132 27.1736C133.796 27.2211 133.474 27.3411 133.188 27.5236C132.729 27.8685 132.327 28.286 132.002 28.761V34.6406H129.934V27.791Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.554 38.3854C136.301 38.3429 136.05 38.2829 135.804 38.2029L136.182 36.678C136.358 36.7255 136.534 36.763 136.713 36.793C136.914 36.828 137.117 36.848 137.318 36.848C138.244 36.848 138.934 36.2505 139.386 35.0581L139.522 34.7181L136.172 25.4937H138.396L140.096 30.6483C140.314 31.3108 140.49 31.9883 140.624 32.6732C140.783 32.0133 140.967 31.3508 141.18 30.6908L142.876 25.4937H144.968L141.632 34.7581C141.379 35.5056 141.039 36.2155 140.612 36.878C140.287 37.3779 139.843 37.7879 139.321 38.0704C138.76 38.3454 138.145 38.4804 137.522 38.4629C137.194 38.4629 136.869 38.4379 136.547 38.3829L136.554 38.3854Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.3682 10.667H62.0664L61.9646 11.5694H59.4478V13.3143H61.8182V14.1543H59.4478V16.0867H62.0961L62.0043 17.0016H58.3682V10.667Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.6203 13.7693L62.6744 10.667H63.908L65.2309 12.9469L66.6208 10.667H67.8196L65.8737 13.7293L67.9785 16.9991H66.7276L65.2284 14.5068L63.702 16.9991H62.5032L64.6178 13.7668L64.6203 13.7693Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7777 10.667H70.4729C71.2672 10.667 71.8777 10.8295 72.3022 11.157C72.5131 11.3245 72.6819 11.5394 72.7911 11.7869C72.9003 12.0344 72.95 12.3044 72.9351 12.5744C72.9475 12.9594 72.8507 13.3418 72.6571 13.6743C72.4685 13.9868 72.193 14.2393 71.8653 14.3968C71.5005 14.5693 71.1009 14.6568 70.6988 14.6493C70.4183 14.6443 70.1403 14.6168 69.8648 14.5618V17.0016H68.7777V10.667ZM71.503 13.4943C71.6221 13.3793 71.7139 13.2393 71.7735 13.0868C71.8331 12.9319 71.8604 12.7669 71.8504 12.6019C71.8653 12.4444 71.8405 12.2844 71.7785 12.1369C71.7164 11.9894 71.6196 11.8619 71.498 11.7619C71.1853 11.5694 70.8204 11.4794 70.4555 11.5044H69.8673V13.7443C70.0733 13.7818 70.2818 13.8043 70.4928 13.8093C70.8576 13.8368 71.2175 13.7243 71.5054 13.4968L71.503 13.4943Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0098 10.667H75.0944V16.0667H77.6956L77.6037 17.0016H74.0098V10.667Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.3461 16.6892C78.8894 16.4317 78.5221 16.0417 78.2888 15.5692C78.0356 15.0468 77.9115 14.4693 77.9239 13.8893C77.9115 13.2819 78.0431 12.6794 78.3136 12.1369C78.5593 11.647 78.9465 11.242 79.4256 10.977C79.9617 10.6945 80.5598 10.557 81.163 10.5795C81.7338 10.5645 82.2972 10.6995 82.8011 10.9745C83.2528 11.2345 83.6202 11.6245 83.8485 12.0944C84.0967 12.6119 84.2183 13.1819 84.2059 13.7543C84.2208 14.3693 84.0868 14.9768 83.8138 15.5267C83.5655 16.0142 83.1784 16.4192 82.7018 16.6867C82.1756 16.9691 81.5874 17.1091 80.9917 17.0966C80.4159 17.1116 79.8475 16.9716 79.3436 16.6917L79.3461 16.6892ZM82.1607 15.9142C82.466 15.7092 82.7043 15.4167 82.8458 15.0743C83.0021 14.6818 83.0791 14.2618 83.0716 13.8393C83.0791 13.4244 83.0096 13.0119 82.8706 12.6219C82.7465 12.2844 82.5231 11.9919 82.2302 11.782C81.8927 11.5745 81.503 11.462 81.1059 11.462C80.7088 11.462 80.3191 11.572 79.9815 11.782C79.6738 11.9969 79.4355 12.2969 79.2915 12.6444C79.1327 13.0194 79.0557 13.4269 79.0607 13.8343C79.0533 14.2543 79.1277 14.6743 79.2766 15.0668C79.4107 15.4267 79.6539 15.7342 79.9716 15.9442C80.2893 16.1542 80.6666 16.2567 81.0463 16.2367C81.441 16.2467 81.8281 16.1342 82.1582 15.9142H82.1607Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4196 10.667H87.3878C87.9636 10.627 88.5394 10.7795 89.0185 11.102C89.2021 11.247 89.3511 11.437 89.4479 11.652C89.5447 11.867 89.5893 12.1044 89.5744 12.3394C89.5819 12.6469 89.5124 12.9494 89.3734 13.2244C89.2518 13.4644 89.0855 13.6768 88.8795 13.8493C88.6958 13.9993 88.4898 14.1168 88.2689 14.2018L90.2148 17.0016H88.949L87.3108 14.4818H86.5141V17.0016H85.4196V10.667ZM87.1247 13.6643C87.3655 13.6693 87.6062 13.6169 87.8221 13.5094C88.0182 13.4144 88.182 13.2669 88.2987 13.0819C88.4129 12.8844 88.4724 12.6594 88.4675 12.4294C88.4799 12.2969 88.4575 12.1644 88.4054 12.0419C88.3533 11.9195 88.2714 11.8145 88.1671 11.732C87.9065 11.567 87.6012 11.4895 87.2935 11.512H86.5067V13.6768L87.1247 13.6668V13.6643Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0612 10.667H94.7668L94.6601 11.5694H92.1582V13.3143H94.5062V14.1543H92.1359V16.0867H94.7842L94.7023 17.0016H91.0587V10.667H91.0612Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8001 10.667H99.8847V17.0016H98.8001V10.667Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.754 11.5794H100.808L100.902 10.667H105.794L105.695 11.5794H103.841V16.9991H102.754V11.5794Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_69963_26295",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 3,
    width: 139,
    height: 42
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M154 3H15V45H154V3Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_69963_26295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.51 16.6891C110.056 16.4317 109.689 16.0417 109.458 15.5692C109.202 15.0467 109.076 14.4718 109.091 13.8893C109.078 13.2818 109.21 12.6794 109.48 12.1369C109.728 11.6469 110.116 11.2445 110.592 10.977C111.123 10.6945 111.719 10.552 112.32 10.567C112.898 10.552 113.469 10.692 113.973 10.972C114.427 11.2295 114.792 11.6219 115.02 12.0919C115.268 12.6094 115.392 13.1769 115.382 13.7518C115.397 14.3668 115.263 14.9742 114.988 15.5242C114.74 16.0142 114.352 16.4167 113.876 16.6841C113.35 16.9666 112.761 17.1066 112.166 17.0941C111.587 17.1091 111.017 16.9691 110.513 16.6891H110.51ZM113.327 15.9142C113.633 15.7092 113.868 15.4167 114.007 15.0742C114.164 14.6818 114.241 14.2618 114.233 13.8393C114.241 13.4243 114.171 13.0119 114.032 12.6219C113.908 12.2844 113.687 11.9919 113.394 11.7819C113.054 11.5719 112.665 11.462 112.268 11.462C111.87 11.462 111.481 11.5719 111.141 11.7819C110.833 11.9969 110.595 12.2969 110.451 12.6444C110.294 13.0219 110.215 13.4268 110.22 13.8343C110.212 14.2543 110.287 14.6743 110.436 15.0667C110.567 15.4117 110.801 15.7092 111.101 15.9242C111.431 16.1417 111.818 16.2517 112.213 16.2367C112.608 16.2442 112.992 16.1317 113.322 15.9142H113.327Z",
    fill: "white"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.584 10.667H117.83L120.94 15.5767C120.912 15.1092 120.9 14.6818 120.9 14.2868V10.6695H121.905V17.0041H120.699L117.539 12.0169C117.569 12.5769 117.586 13.0843 117.586 13.5243V17.0041H116.581V10.6695L116.584 10.667Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0789 10.6996H31.5401C26.0995 10.6996 24.1089 12.7045 24.1089 18.1841V29.8159C24.1089 35.2956 26.0995 37.3005 31.5401 37.3005H43.0789C48.5195 37.3005 50.5126 35.2956 50.5126 29.8159V18.1841C50.5175 12.7045 48.527 10.6996 43.0789 10.6996Z",
    fill: "#C8102E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3361 24.0013H30.036V27.4811H29.3361V26.0662H27.755V27.4811H27.0551V24.0013H27.755V25.4012H29.3361V24.0013ZM33.285 25.9912C33.285 26.5511 33.007 26.8586 32.5006 26.8586C31.9943 26.8586 31.7114 26.5511 31.7114 25.9587V23.9988H31.0114V25.9862C31.0114 26.9636 31.55 27.5236 32.4907 27.5236C33.4314 27.5236 33.9874 26.9636 33.9874 25.9562V23.9988H33.2874V25.9887L33.285 25.9912ZM41.3813 26.3911L40.597 23.9988H40.0211L39.2418 26.3936L38.4773 23.9988H37.7327L38.9365 27.4786H39.5173L40.2991 25.1937L41.0834 27.4786H41.6692L42.873 23.9988H42.1457L41.3813 26.3911ZM44.1289 25.9787H45.4046V25.3487H44.1289V24.6387H45.9804V24.0013H43.4389V27.4736H46.0475V26.8461H44.1289V25.9812V25.9787ZM46.8814 27.4711H47.5739V23.9988H46.8814V27.4711ZM35.3723 26.7511L35.0571 27.4736H34.3423L35.8514 23.9988H36.4694L37.9834 27.4736H37.2611L36.9633 26.7536H35.3698L35.3723 26.7511ZM35.6329 26.1237H36.6853L36.1566 24.8812L35.6305 26.1237H35.6329Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3132 19.574C36.1467 19.574 35.0298 19.1065 34.2058 18.2765C33.3817 17.4466 32.9176 16.3217 32.9176 15.1467H33.5381C33.5381 16.1542 33.9352 17.1216 34.6451 17.8366C35.3525 18.549 36.313 18.949 37.3157 18.949C38.3185 18.949 39.2765 18.549 39.9864 17.8366C40.6937 17.1241 41.0933 16.1567 41.0933 15.1467H41.7138C41.7138 16.3217 41.2497 17.4466 40.4257 18.2765C39.6017 19.1065 38.4847 19.574 37.3182 19.574H37.3132Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69963_26295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139,
    height: 42,
    fill: "white",
    transform: "translate(15 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnHuawei);
export default __webpack_public_path__ + "static/media/btn_huawei.e5483da074f8593571efc5b88e533b00.svg";
export { ForwardRef as ReactComponent };